import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconWallet';
/** Renders an SVG icon. */
const SvgWallet = ({ size, 'aria-hidden': ariaHidden, tone, UNSAFE_className, UNSAFE_style, ...rest }: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        d="M22 16v2h5v-2zm-.465-9.736a1 1 0 0 0-1.252-.717L11.943 8H21.97zM26 11a1 1 0 0 0-1-1H6v13a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-3h-4a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h4zm2 3.269c.598.346 1 .991 1 1.731v2c0 .74-.403 1.384-1 1.73V23a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V9a1 1 0 0 1 .718-.96l15-4.412a3 3 0 0 1 3.758 2.152l.494 1.977q.03.122.029.243H25a3 3 0 0 1 3 3z"
      />
    </svg>
  );
};
SvgWallet.displayName = displayName;
export default SvgWallet;
